/*
 * fawn hero slideshow — slow crossfade + ken-burns, pause on hover, swipe, dots.
 * First slide is already .is-active in the HTML, so the hero shows even if this never runs.
 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(document.querySelectorAll('[data-fawn-slideshow]'), function (root) {
    var slides = root.querySelectorAll('.fawn-hero__slide');
    var dots = root.querySelectorAll('.fawn-hero__dot');
    if (slides.length < 2 || reduce) return; // static first slide

    var i = 0, timer, paused = false;

    function show(n) {
      n = (n + slides.length) % slides.length;
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = n;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
    }
    function next() { if (!paused && !document.hidden) show(i + 1); }
    function start() { timer = setInterval(next, 6500); }
    function restart() { clearInterval(timer); start(); }

    start();
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });

    Array.prototype.forEach.call(dots, function (d, idx) {
      d.addEventListener('click', function () { show(idx); restart(); });
    });

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { show(dx < 0 ? i + 1 : i - 1); restart(); }
      x0 = null;
    }, { passive: true });
  });
})();
